<template>
  <div>
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li><router-link to="/clients">Applications</router-link></li>
        <li class="is-active"><a href="#" aria-current="page">{{ this.$store.state.client.name }}</a></li>
      </ul>
    </nav>

    <div class="columns">
      <div class="column is-4 is-offset-1">
        <p class="title is-4">{{ this.$store.state.client.name }}</p>
        <p><span class="has-text-grey">Application ID:</span> {{ $route.params.client_id }}</p>
        <p><span class="has-text-grey">Platform:</span> {{ this.$store.state.client.platform }}</p>
        <p><span class="has-text-grey">Created at:</span> {{ this.$store.state.client.created_at }}</p>
        <p><span class="has-text-grey">Updated at:</span> {{ this.$store.state.client.updated_at }}</p>
      </div>
      <div class="column is-2">
        <nav class="level">
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Mobile devices total</p>
              <router-link v-bind:to="`/clients/${this.$store.state.client.id}/devices`">
                <p class="subtitle is-4 has-text-primary">{{ this.$store.state.clientDevicesTotal | numberDisplay }}</p>
              </router-link>
            </div>
          </div>
        </nav>
      </div>
      <div class="column is-4 is-offset-1">
        <div class="control is-grouped">
          <div class="control">
            <router-link v-bind:to="`/clients/${this.$store.state.client.id}/edit`" class="button is-primary is-outlined">
              <span class="icon"><i class="fa fa-lg fa-pencil"></i></span>
              <span>Edit</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    created () {
      this.$store.dispatch('getClient', {
        clientId: this.$route.params.client_id
      })
      this.$store.dispatch('getClientDevices', {
        clientId: this.$route.params.client_id,
        params: { limit: 1 }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// ClientView.vue?666fadb6